var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { createEmbed } from '../elements/create-embed';
import { ImageAssetEmbed } from '../entities/image-asset-embed';
import { PersonEmbed } from '../entities/person-embed';
import { PageChildrenEmbed } from '../entities/page-children-embed';
import { EntityCell } from '../entities/entity-cell';
import { CitationEmbed } from '../entities/citation-embed';
import { MarkdownContentLink } from '../elements/markdown-content-link';
import { OutlineEntityEmbed } from '../entities/outline-entity-embed';
import { HorizontalScroll } from '../elements/horizontal-scroll';
import { OutlineEntityDotLink } from '../entities/outline-entity-dot-link';
export var EmbedComponentsContext = React.createContext({});
var PersonStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(4))
});
var ChildrenStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ImageAssetStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: ", " 0 ", " 0;\n    ", "\n  "], ["\n    margin: ", " 0 ", " 0;\n    ", "\n  "])), theme.UNIT(8), theme.UNIT(14), function (props) {
    return props.nomargin && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      margin-bottom: ", ";\n    "], ["\n      margin-bottom: ", ";\n    "])), theme.UNIT(2));
  })
});
var PageStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin: ", " 0 ", ";\n    max-width: 750px;\n  "], ["\n    margin: ", " 0 ", ";\n    max-width: 750px;\n  "])), theme.UNIT(4), theme.UNIT(8))
});
var EntityStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin: ", " 0 ", ";\n    max-width: 750px;\n  "], ["\n    margin: ", " 0 ", ";\n    max-width: 750px;\n  "])), theme.UNIT(4), theme.UNIT(8))
});
var CitationStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(2))
});
var TrendEmbedStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-bottom: 1.5em;\n    margin-top: 2.5em;\n  "], ["\n    margin-bottom: 1.5em;\n    margin-top: 2.5em;\n  "])))
});
var EntityEmbedStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin: ", " 0 ", ";\n    max-width: 750px;\n  "], ["\n    margin: ", " 0 ", ";\n    max-width: 750px;\n  "])), theme.UNIT(4), theme.UNIT(8))
});
var ScrollStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var OutlineEntityLinkStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin: ", " 0 ", ";\n \n  "], ["\n    margin: ", " 0 ", ";\n \n  "])), theme.UNIT(4), theme.UNIT(8))
});
var My = {
  ImageAsset: styled(ImageAssetEmbed)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ImageAssetStyles),
  Person: styled(PersonEmbed)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), PersonStyles),
  Children: styled(PageChildrenEmbed)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ChildrenStyles),
  Entity: styled(EntityCell)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), EntityStyles),
  Citation: styled(CitationEmbed)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), CitationStyles),
  Page: styled(EntityCell)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), PageStyles),
  TrendEmbed: styled(OutlineEntityEmbed)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), TrendEmbedStyles),
  EntityEmbed: styled(EntityCell)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), EntityEmbedStyles),
  Scroll: styled(HorizontalScroll)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ScrollStyles),
  OutlineEntityLink: styled(OutlineEntityDotLink)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), OutlineEntityLinkStyles)
};
export var EmbedComponentsProvider = function EmbedComponentsProvider(_a) {
  var value = _a.value,
      children = _a.children;
  var defaultValues = {
    a: {
      component: MarkdownContentLink
    },
    Person: createEmbed('people', My.Person, function (attr) {
      return {
        showPosition: !(attr.nopos || attr.noposition),
        showOrganisation: !attr.noorg,
        link: !attr.nolink,
        showImage: !(attr.noimage || attr.noimg)
      };
    }),
    Citation: createEmbed('citations', My.Citation),
    ImageAsset: createEmbed('imageAssets', My.ImageAsset, function (attr) {
      return {
        href: attr.href,
        longdesc: attr.longdesc,
        alt: attr.alt,
        title: attr.title,
        nomargin: !!attr.nomargin,
        width: attr.width,
        nozoom: attr.nozoom
      };
    }),
    Scroll: My.Scroll,
    Children: My.Children,
    Page: createEmbed('pages', My.Page),
    Trend: createEmbed('trends', My.TrendEmbed),
    Topic: createEmbed('topics', My.OutlineEntityLink),
    SubTopic: createEmbed('subTopics', My.OutlineEntityLink)
  };

  var providerValue = __assign(__assign({}, defaultValues), value);

  return React.createElement(EmbedComponentsContext.Provider, {
    value: providerValue
  }, children);
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;